import { sendCastleCustomEvent } from "./castle";

export const CASTLE_SIGNUP_ATTEMPTED_EVENT = "WAC Signup Attempted";

const MAX_PATH_SEGMENT_LENGTH = 48;
const SAFE_QUERY_PARAM_NAMES = new Set([
    "bundle",
    "edition",
    "product",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term"
]);

const getUrl = (href: string) => {
    try {
        return new URL(href, window.location.origin);
    } catch {
        return undefined;
    }
};

const getSafeSearchParams = (url: URL) => {
    const safe = new URLSearchParams();

    url.searchParams.forEach((value, name) => {
        if (SAFE_QUERY_PARAM_NAMES.has(name)) {
            safe.append(name, value);
        }
    });

    return safe.toString();
};

const sanitizePathSegment = (segment: string) => {
    if (segment.length > MAX_PATH_SEGMENT_LENGTH) {
        return "[redacted]";
    }

    return segment;
};

const getSanitizedPath = (pathname: string) => {
    return pathname
        .split("/")
        .map((segment) => sanitizePathSegment(segment))
        .join("/");
};

const getSanitizedHref = (url: URL) => {
    const safeParams = getSafeSearchParams(url);
    const safePath = getSanitizedPath(url.pathname);
    const base = `${url.origin}${safePath}`;

    return safeParams ? `${base}?${safeParams}` : base;
};

const getSanitizedPagePath = () => getSanitizedPath(window.location.pathname);

export const trackCastleSignupAttempt = ({
    href,
    email,
    productKey
}: {
    href: string;
    email: string;
    productKey?: string;
}) => {
    const url = getUrl(href);

    if (!url) {
        return;
    }

    sendCastleCustomEvent({
        name: CASTLE_SIGNUP_ATTEMPTED_EVENT,
        properties: {
            wac_href: getSanitizedHref(url),
            wac_pagePath: getSanitizedPagePath(),
            wac_eventType: "signup",
            ...(productKey ? { wac_productKey: productKey } : {})
        },
        email
    });
};
